import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import type { ProductCart, ProductDetails } from '../../../../models/src/lib/models';

// Interface for the data our modal needs
export interface EngravingModalData {
  product: ProductCart | ProductDetails;
  initialEngraving: string | null;
  isDisabled?: boolean;
  existingEngraving?: string // New optional property for existing engraving text
}
export interface EngravingSkipResult {
  productId: number
}

// Interface for the result when the modal is saved
export interface EngravingModalResult {
  productId: number;
  engravingText: string;
}
export interface DisabledEngravingModalData {
  product: ProductCart | ProductDetails
  engravingText: string
}


@Injectable({
  providedIn: 'root',
})
export class EngravingModalService {
  // Use a BehaviorSubject to hold the modal's visibility state
  private readonly _isModalOpen = new BehaviorSubject<boolean>(false);
  public readonly isModalOpen$ = this._isModalOpen.asObservable();

  // Use a BehaviorSubject to hold the data for the currently open modal
  private readonly _modalData = new BehaviorSubject<EngravingModalData | null>(null);
  public readonly modalData$ = this._modalData.asObservable();

  private readonly _engravingSkipped = new Subject<EngravingSkipResult>()
  public readonly engravingSkipped$ = this._engravingSkipped.asObservable()
  // Use a Subject to emit the result when the user saves the engraving
  private readonly _engravingResult = new Subject<EngravingModalResult>();
  public readonly engravingResult$ = this._engravingResult.asObservable();

   openModal(data: EngravingModalData): void {
    this._modalData.next({
      ...data,
      isDisabled: false,
    })
    this._isModalOpen.next(true)
  }

  openDisabledModal(data: DisabledEngravingModalData): void {
    const modalData: EngravingModalData = {
      product: data.product,
      initialEngraving: null,
      isDisabled: true,
      existingEngraving: data.engravingText,
    }

    this._modalData.next(modalData)
    this._isModalOpen.next(true)
  }

  closeModal(): void {
    this._isModalOpen.next(false);
    this._modalData.next(null); // Clear data on close
  }

  saveEngraving(productId: number, engravingText: string): void {
    this._engravingResult.next({ productId, engravingText });
    this.closeModal();
  }
  skipEngraving(productId: number): void {
    this._engravingSkipped.next({ productId })
    this.closeModal()
  }
  get isModalOpen(): boolean {
    return this._isModalOpen.value
  }

  get currentModalData(): EngravingModalData | null {
    return this._modalData.value
  }

  get isDisabledMode(): boolean {
    return this.currentModalData?.isDisabled === true
  }
}
